import { Const } from '../constants/Constants';
import { Session } from '../objectType/Session';

export const SessionValues = () => {
  // sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.COMPANY_CD, '1');
  // sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.COMPANY_NAME, 'トランコムITS株式会社');
  // sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.ACCOUNT_ID, '2');
  // sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.TANTO_NAME, 'its-user');
  // sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD, '123456');
  // sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD2, '001');
  // sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.JISHA_KBN, '1');
  // sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.JYU_NO, '1234567890');
  // sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.KYOTEN_CD, '0001');

  let session: Session = {
    companyCd: sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_CD) ?? '',
    companyName: sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_NAME) ?? '',
    accountId: sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.ACCOUNT_ID) ?? '',
    tanName: sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TANTO_NAME) ?? '',
    tokCd: sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD) ?? '',
    tokCd2: sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD2) ?? '',
    jishaKbn: sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.JISHA_KBN) ?? '',
    jyuNo: sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.JYU_NO) ?? '',
    kyotenCd: sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.KYOTEN_CD) ?? '',
    moveKbn: sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.MOVE_KBN) ?? '',
  };
  return session;
};
